import { render, staticRenderFns } from "./ButtonFAQ.vue?vue&type=template&id=93c85190"
import script from "./ButtonFAQ.vue?vue&type=script&lang=ts"
export * from "./ButtonFAQ.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports